import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { Card, CardBody, CardHeader, Spinner } from "reactstrap";
import axios from "axios";

const DowntimeAnalyticsBar = ({ machineId }) => {
  const today = new Date();

  const [filterType, setFilterType] = useState("month"); // week | month | year | range
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1);
  const [week, setWeek] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH ---------------- */

  const fetchDowntimeData = async () => {
    if (!machineId) return;

    let params = `machine_id=${machineId}`;

    if (filterType === "month") {
      params += `&year=${year}&month=${month}`;
    } else if (filterType === "year") {
      params += `&year=${year}`;
    } else if (filterType === "week") {
      params += `&year=${year}&week=${week}`;
    } else if (filterType === "range") {
      if (!startDate || !endDate) return;
      params += `&start_date=${startDate}&end_date=${endDate}`;
    }

    try {
      setLoading(true);
      const res = await axios.get(
        `https://api.hanoch.in/api/mcc/machine-downtime-analytics-month/?${params}`
      );
      const reasons =
        res?.breakdown?.top_reasons?.map((r) => ({
          reason: r.reason,
          count: r.count,
        })) || [];
console.log("reasons",res)
      setChartData(reasons);
    } catch (err) {
      console.error(err);
      setChartData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDowntimeData();
  }, [filterType, year, month, week, startDate, endDate, machineId]);

  /* ---------------- UI ---------------- */

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Downtime – Most Occurring Reasons</h5>

        <div className="d-flex gap-2">
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="form-select form-select-sm"
          >
            <option value="week">Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
            <option value="range">Date Range</option>
          </select>

          {filterType === "month" && (
            <input
              type="month"
              value={`${year}-${String(month).padStart(2, "0")}`}
              onChange={(e) => {
                const [y, m] = e.target.value.split("-");
                setYear(+y);
                setMonth(+m);
              }}
            />
          )}

          {filterType === "year" && (
            <input
              type="number"
              value={year}
              onChange={(e) => setYear(+e.target.value)}
              style={{ width: 90 }}
            />
          )}

          {filterType === "week" && (
            <input
              type="number"
              placeholder="Week"
              value={week}
              onChange={(e) => setWeek(e.target.value)}
              style={{ width: 80 }}
            />
          )}

          {filterType === "range" && (
            <>
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            </>
          )}
        </div>
      </CardHeader>


 {loading ? <Spinner size="sm" /> :
      <CardBody style={{ height: 420 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
  data={chartData}
  layout="vertical"   // 👈 THIS is the key
  margin={{ left: 160, right: 20, top: 20, bottom: 20 }}
>
  <CartesianGrid strokeDasharray="3 3" />

  {/* X = numbers */}
  <XAxis type="number" />

  {/* Y = categories */}
  <YAxis
    type="category"
    dataKey="reason"
    width={300}
    tick={{ fontSize: 12 }}
  />

  <Tooltip />
  <Bar dataKey="count" fill="#87c5a7" />
</BarChart>

        </ResponsiveContainer>
      </CardBody>
}
    </Card>
  );
};

export default DowntimeAnalyticsBar;
